<template>
    <div class="container mx-auto p-6">
        <section class="my-8">
            <h1 class="text-4xl font-bold text-center font-orbitron mb-6">We make AI Agents</h1>
        </section>
        <section class="my-8">
            <div>
                <p class="text-lg mt-4 font-roboto">AI agents are designed to perform tasks that range from simple to
                    complex, with the aim of enhancing efficiency, accuracy, and convenience across various domains.</p>
                <ul class="list-disc list-inside space-y-2 mt-4 text-lg font-roboto">
                    <li><strong>Automation</strong>: AI agents automate repetitive tasks, saving time and reducing human
                        error.</li>
                    <li><strong>Decision Making</strong>: AI agents analyze data and make decisions based on predefined
                        rules or learned patterns.</li>
                    <li><strong>Personalization</strong>: AI agents personalize user experiences by analyzing user
                        behavior and preferences.</li>
                    <li><strong>Prediction</strong>: AI agents can forecast future outcomes based on historical data.
                    </li>
                    <li><strong>Optimization</strong>: AI agents optimize processes to improve efficiency and
                        performance.</li>
                    <li><strong>Assistance</strong>: AI agents provide assistance to users by answering questions,
                        providing information, or guiding users through tasks. <router-link to="/ai-agents/custom-gpts" class="btn-open-form text-blue-500 hover:text-blue-700">Take a look at our public GPT Agents</router-link>.</li>
                    <li><strong>Learning and Adaptation</strong>: AI agents can learn from data and adapt their behavior
                        accordingly.</li>
                    <li><strong>Exploration</strong>: AI agents are used in exploration tasks where it may be dangerous
                        or impractical for humans to go.</li>
                </ul>
                <p class="text-lg mt-4 font-roboto">We specialize in empowering your company with cutting-edge AI agent development, whether they're embodied in robotic hardware or powered by innovative software solutions. Learn more about our expertise on our  <router-link to="/about-us" class="text-blue-600 hover:text-blue-800 underline">About page</router-link>.</p>
            </div>
        </section>

        <section class="my-8 border-t border-gray-200 pt-8">
            <h3 class="text-2xl md:text-3xl font-orbitron font-semibold">Have a workflow in mind?</h3>
            <p class="mt-4 text-lg font-roboto text-gray-700">
                An AI Agent Sprint takes two to four weeks and ends with a working agent wired into your own tools and
                data — prompts, evaluation set, and deployment scripts included.
            </p>
            <div class="mt-6 flex flex-wrap gap-4">
                <router-link :to="{ path: '/contact', query: { service: 'AI Agent Sprint' } }" class="btn-primary">
                    Start a project
                </router-link>
                <router-link to="/ai-agents/custom-gpts" class="btn-secondary">See our GPT agents</router-link>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'AIAgentsComponent',
};
</script>
